import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Header from '../../../../../../../components/Stake/header';
import * as labsStakeActions from '../../../../../../../actions/labs-stake-actions';
import LabsIcon from '../../../../../../../assets/images/labs-icon.svg';
import { LABS } from '../../../../../../../constants/blockchain-constants';
import ClosedStub from '../../closed-stub';

const StakeSettings = () => {
  const dispatch = useDispatch();
  const { stakeBalance, unstakedBalance } = useSelector((state) => state.LABSstake.stake);

  const isNotFirstFrame = [stakeBalance, unstakedBalance].some((value) => value !== '0');
  const onClickBack = isNotFirstFrame ? () => dispatch(labsStakeActions.stakeReset()) : null;

  return (
    <>
      <Header icon={LabsIcon} title={`${LABS}-Staking`} onClickBack={onClickBack} />
      <ClosedStub text={'The LABS staking pool is closed.'} />
    </>
  );
};

export default StakeSettings;
